import React from "react";
import { Card, CardBody } from "reactstrap";
import { ReactComponent as BadBotLogo } from "@/assets/img/svg/bad-bot-logo.svg";
import { DOSELECT_SUPPORT_EMAIL } from "@/constants/AppConstants";
import styles from "./ErrorBoundary.module.css";

function ErrorBoundaryFallback() {
  return (
    <div className={styles.cardContainer}>
      <Card className={`${styles.card} col-sm-12 col-md-12 col-lg-10 col-xl-8`}>
        <CardBody className={styles.cardBody}>
          <div>
            <BadBotLogo />
          </div>
          <div>
            <div className={styles.title}>Drats! Something&apos;s wrong.</div>
            <div className={styles.subTitle}>
              Something went wrong, Try to refresh the page. If issue still
              persists, please contact <strong>{DOSELECT_SUPPORT_EMAIL}</strong>
            </div>
          </div>
        </CardBody>
      </Card>
    </div>
  );
}

export default ErrorBoundaryFallback;
